import React, { useState } from "react";
import Layout from '../form-layout'

// Q21 — "Is there any other information you feel would be useful for our doctor to
// know about?" Yes/No; "Yes" reveals a free-text box. Submission itself (the POST to
// /form/save) happens on the acknowledgement screen (Q22) that follows.
export default function Step10C({ formData, setFormData, onBack, goToStep }) {
  const [answer, setAnswer] = useState(formData.otherInfoAnswer || "");
  const [additionalInfo, setAdditionalInfo] = useState(
    formData.additionalInfo || localStorage.getItem("additionalInfo") || ""
  );

  // Females always pass through pregnancyNotice right before this screen (default
  // index back is correct there regardless of form). For males, which screen is
  // actually the predecessor depends on how much of the Q13-18 pathway ran:
  //  - Form B: the whole pathway is skipped (see allergy-check.jsx) -> back to "10"
  //  - Form A, Q13 answered "None of the above": 14-18 skipped -> back to "13"
  //  - Form A, Q13 answered a real medication: full 14-18 ran -> default back ("18") is correct
  const handleBack = () => {
    if (formData.biologicalSex === "Female") {
      onBack();
      return;
    }
    if (formData.glp1History === "current") {
      goToStep("10");
    } else if (!formData.glp1TriedMedication || formData.glp1TriedMedication === "none") {
      goToStep("13");
    } else {
      onBack();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!answer) return;
    if (answer === "Yes" && !additionalInfo.trim()) return;

    localStorage.setItem("otherInfoAnswer", answer);
    localStorage.setItem("additionalInfo", additionalInfo);
    setFormData((prev) => ({ ...prev, otherInfoAnswer: answer, additionalInfo }));

    goToStep("acknowledgement");
  };

  return (
    <Layout title="" goToStep={goToStep} onBack={handleBack}>
      <h2 className="text-sm sm:text-[14px] font-medium text-[#000000] mb-4 text-center">
        Is there any other information you feel would be useful for our doctor to know about?
      </h2>

      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <div className="flex gap-6 justify-center">
          {["Yes", "No"].map((option) => (
            <label key={option} className="inline-flex items-center gap-2 cursor-pointer p-2">
              <input
                type="radio"
                name="otherInfoAnswer"
                checked={answer === option}
                onChange={() => setAnswer(option)}
                className="h-4 w-4 accent-[#35C3D9]"
              />
              <span className="text-gray-800">{option}</span>
            </label>
          ))}
        </div>

        {answer === "Yes" && (
          <textarea
            value={additionalInfo}
            onChange={(e) => setAdditionalInfo(e.target.value)}
            placeholder="Please tell us more"
            rows={5}
            className="w-full border-2 border-sky-400 rounded-lg p-3 text-sm sm:text-[14px] text-gray-800 outline-none transition focus:border-sky-500"
          />
        )}

        <div className="flex justify-start mt-2">
          <button
            type="submit"
            disabled={!answer || (answer === "Yes" && !additionalInfo.trim())}
            className={`w-[210px] text-sm font-semibold rounded-lg py-3 transition-colors
              ${
                !answer || (answer === "Yes" && !additionalInfo.trim())
                  ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                  : "bg-[#35C3D9] text-white hover:bg-[#27AAC0]"
              }`}
          >
            Next →
          </button>
        </div>
      </form>
    </Layout>
  );
}
